/**
 * Constructeur d'URL unique (§7 bis.2).
 *
 * Aucune concaténation de chaînes ailleurs, aucun slash en dur, gestion du « / »
 * final centralisée ici. Toutes les bases viennent de la configuration validée :
 * ce fichier ne contient aucun domaine, aucun hôte, aucun port.
 */
function joindre(base, chemin, parametres) {
    const baseNettoyee = base.replace(/\/+$/, '');
    const cheminNettoye = chemin === '' ? '' : `/${chemin.replace(/^\/+/, '')}`;
    const url = `${baseNettoyee}${cheminNettoye}`;
    if (!parametres)
        return url;
    const recherche = new URLSearchParams();
    for (const [cle, valeur] of Object.entries(parametres)) {
        if (valeur === undefined || valeur === null || valeur === '')
            continue;
        if (Array.isArray(valeur)) {
            for (const v of valeur)
                recherche.append(cle, String(v));
        }
        else {
            recherche.set(cle, String(valeur));
        }
    }
    const chaine = recherche.toString();
    return chaine ? `${url}?${chaine}` : url;
}
export const PREFIXE_API = '/api/v1';
export function creerConstructeursUrl(env) {
    return {
        apiUrl: (chemin, parametres) => joindre(env.PUBLIC_API_URL, `${PREFIXE_API}/${chemin.replace(/^\/+/, '')}`, parametres),
        appUrl: (chemin, parametres) => joindre(env.PUBLIC_APP_URL, chemin, parametres),
        webUrl: (chemin, parametres) => joindre(env.PUBLIC_WEB_URL, chemin, parametres),
        authUrl: (chemin, parametres) => joindre(env.PUBLIC_AUTH_URL, chemin, parametres),
    };
}
/** Variante typée sur la configuration publique complète. */
export function constructeursDepuisEnv(env) {
    return creerConstructeursUrl(env);
}
//# sourceMappingURL=urls.js.map